import type { ReplaceKind } from '@avs/contract';

export type WizardPair = {
  id: string;
  videoAssetId: string;
  refAssetIds: string[];   // 每行可多选参考素材
};

export type WizardParams = {
  strategy: string;
  resolution: '720p' | '1080p' | '2K';
  duration: '5 秒' | '10 秒' | '15 秒';
  retries: number;
  promptOverride: string;  // 留空走该 kind 的默认 prompt
  replaceTarget: string;   // Slice 12：物体替换「要换掉的东西」（给 SAM3 自动识别，英文更准）
};

export type WizardState = {
  kind: ReplaceKind;
  name: string;
  pairs: WizardPair[];
  params: WizardParams;
};

export const WIZARD_STEPS = ['配对', '调整参数', '预览确认', '执行'] as const;
export type WizardStep = 0 | 1 | 2 | 3;

/** 展开成 (video, ref) 对，每对 = 1 个任务（1 额度） */
export function expandPairs(pairs: WizardPair[]): Array<{ videoAssetId: string; refAssetId: string }> {
  const out: Array<{ videoAssetId: string; refAssetId: string }> = [];
  for (const p of pairs) {
    for (const r of p.refAssetIds) {
      out.push({ videoAssetId: p.videoAssetId, refAssetId: r });
    }
  }
  return out;
}
